import { isValidUuid } from '@/util/is-valid-uuid'
import { useCallback } from 'react'
import { useSearchParams, type NavigateOptions } from 'react-router-dom'

/** URL param naming the open draft (its matter artifact version id). */
export const kDraftSearchParam = 'draft'

/**
 * Which draft the document-first layout shows. Backed by the URL so it survives reload and is
 * shareable, and centralized here so callers never hardcode the param name.
 */
export function useDraftWorkspace() {
  const [searchParams, setSearchParams] = useSearchParams()
  const requestedDraftArtifactVersionId = searchParams.get(kDraftSearchParam)
  // A value that is not a version id is ignored, so a malformed link lands on the conversation instead of a draft that can never load.
  const draftArtifactVersionId = isValidUuid(requestedDraftArtifactVersionId) ? requestedDraftArtifactVersionId : null

  const openDraft = useCallback(
    (matterArtifactVersionId: string, navigateOptions?: NavigateOptions) => {
      const next = new URLSearchParams(searchParams)
      next.delete('table')
      next.set(kDraftSearchParam, matterArtifactVersionId)
      setSearchParams(next, navigateOptions)
    },
    [searchParams, setSearchParams]
  )

  const closeDraft = useCallback(() => {
    const next = new URLSearchParams(searchParams)
    next.delete(kDraftSearchParam)
    setSearchParams(next)
  }, [searchParams, setSearchParams])

  return { draftArtifactVersionId, openDraft, closeDraft }
}
